export const MUTATION_ENDPOINT_MAX_BODY_SIZE = 1024 * 256 // 256KB
export const DEFAULT_MUTATION_CONCURRENCY = 6
export const MAX_MUTATION_CONCURRENCY = 10
